import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepSupportingDocuments = (state) => state.get('stepSupportingDocuments');

const makeSelectStepSupportingDocuments = () => createSelector(
  selectStepSupportingDocuments,
  (stepSupportingDocumentsState) => ({
    attachDocuments: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'attachDocuments']).toJS(), ''),
    uploadPercentage: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'uploadPercentage']), ''),
    progressBarVisibility: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'progressBarVisibility']), ''),
    showWarningMissingRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'showWarningMissingRequiredDocument']), ''),
    showWarningInvalidRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'showWarningInvalidRequiredDocument']), ''),
    warningMissingRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'warningMissingRequiredDocument']), ''),
    validationMessages: mapWithDefault(stepSupportingDocumentsState, () => {
      const validationMessages = stepSupportingDocumentsState.getIn(['form', 'validationMessages']);
      return validationMessages ? validationMessages.toJS() : [];
    }, []),
  })
);

const makeSelectStepSupportingDocumentsErrors = () =>
  createSelector(selectStepSupportingDocuments, (state) => state.get('errors'));

export {
  makeSelectStepSupportingDocuments,
  makeSelectStepSupportingDocumentsErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/selectors.js